import { curveRightUp, curveDownRight } from 'app/views/hybrid/utils/d3/curves';
import { AWS_ENTITY_TYPES } from '@kentik/ui-shared/hybrid/constants';
import { connectThroughMiddleXCurved } from './commonUtilsCurved';

/**
 *      Subnet
 *      (dest)
 *         ↓
 *           → → → → → →
 *                       ↓
 *                  ← ← ←
 *                ↓
 *         VPC Endpoint
 *           (source)
 */
const connectToSubnet = (props) => connectThroughMiddleXCurved(props);

const connectToFirewall = ({ sourcePoint, targetPoint, ySpacing, linkSpacing, targetNodeHeight }) => {
  const bottomY = targetPoint[1] + targetNodeHeight / 2 + ySpacing / 5;

  const connectionPoints = [
    ...curveDownRight(sourcePoint[0], bottomY, linkSpacing),
    ...curveRightUp(targetPoint[0], bottomY, linkSpacing)
  ];
  return { sourceAnchor: 'bottom', targetAnchor: 'bottom', connectionPoints };
};

/**
 *
 *  @returns {
 *  sourceAnchor: left | right | top | bottom
 *  targetAnchor: left | right | top | bottom
 *  connectionPoints: [ [x, y], [x, y], ... ]
 * }
 */
const VpcEndpointConnector = ({ targetType, ...rest }) => {
  switch (targetType) {
    case 'subnet':
      return connectToSubnet({ ...rest });
    case AWS_ENTITY_TYPES.FIREWALL:
      return connectToFirewall({ ...rest });
    // /** @TODO other target types */
    default:
      return null;
  }
};

export default VpcEndpointConnector;
